import BaseApi from "../../../api/api"
import {
  IOzonOrder,
  OzonProductType,
} from "../../../app/reducers/ordersReducer"
import { NotificationService } from "../../../features/NotificationService/NotificationService"
import {
  IRecodeOzonKatren,
  MissOrderkatren,
  RecodeForOrderkatren,
} from "../FormKatrenOrder"

export const getOzonOrdersForKatren = (
  orders: IOzonOrder[],
): Promise<{
  recodeForOrderkatren: RecodeForOrderkatren[]
  missOrders: MissOrderkatren[]
}> => {
  return BaseApi.loadOzonRecodeKatren().then(
    ({ items, success }: { items: IRecodeOzonKatren; success: boolean }) => {
      if (success) {
        if (items?.length) {
          const missOrders: MissOrderkatren[] = []
          const recodeForOrderkatrenMap = new Map<
            string,
            RecodeForOrderkatren
          >()
          orders.forEach((order) => {
            order.products.forEach((product: OzonProductType) => {
              const recodeItem = items.find(
                (item) => item.offer_id === product.offer_id,
              )
              if (recodeItem?.offer_id) {
                if (recodeForOrderkatrenMap.has(recodeItem.offer_id)) {
                  const recodeForOrderkatrenItem = recodeForOrderkatrenMap.get(
                    recodeItem.offer_id,
                  )
                  if (recodeForOrderkatrenItem) {
                    recodeForOrderkatrenItem.Quantity +=
                      Number(recodeItem.count) * product.quantity || 0
                  } else {
                    recodeForOrderkatrenMap.set(recodeItem.offer_id, {
                      GoodName: recodeItem.name,
                      GoodCode: recodeItem.offer_id,
                      Quantity:
                        Number(recodeItem.count) * product.quantity || 0,
                    })
                  }
                } else {
                  recodeForOrderkatrenMap.set(recodeItem.offer_id, {
                    GoodName: recodeItem.name,
                    GoodCode: recodeItem.offer_id,
                    Quantity: Number(recodeItem.count) * product.quantity || 0,
                  })
                }
              } else {
                missOrders.push({
                  nmId: product.sku,
                  GoodCode: product.offer_id,
                })
              }
            })
          })

          return {
            recodeForOrderkatren: Array.from(recodeForOrderkatrenMap.values()),
            missOrders,
          }
        } else {
          NotificationService.showNotification({
            message: "Перекодировка не найдена",
            level: "error",
          })
        }
      } else {
        NotificationService.showNotification({
          message: "Ошибка при загрузке перекодировки",
          level: "error",
        })
      }
      return {
        recodeForOrderkatren: [],
        missOrders: [],
      }
    },
  )
}
